/**
 * ItemsFilter - Search and filter controls for bucket list items
 */
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Button } from "@/components/ui/button";
import { Search, Filter, MapPin, Compass, Star, Target, Heart, ArrowUpDown } from "lucide-react";

const CATEGORIES = [
  { value: "travel", label: "Travel", icon: MapPin },
  { value: "adventures", label: "Adventures", icon: Compass },
  { value: "experiences", label: "Experiences", icon: Star },
  { value: "goals", label: "Goals", icon: Target },
  { value: "romance", label: "Romance", icon: Heart },
];

const ItemsFilter = ({ 
  searchQuery, 
  onSearchChange, 
  filterCategory, 
  onCategoryChange, 
  filterCompleted, 
  onCompletedChange,
  sortOrder,
  onSortOrderChange
}) => {
  return (
    <div className="mb-6 flex flex-col sm:flex-row gap-4">
      <div className="relative flex-1">
        <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-muted-foreground" />
        <Input
          placeholder="Search your bucket list..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          className="pl-12 h-12 bg-card border-charcoal/10 rounded-xl"
          data-testid="search-input"
        />
      </div>
      
      <div className="flex gap-3 flex-wrap">
        <Select value={filterCategory} onValueChange={onCategoryChange}>
          <SelectTrigger className="w-[160px] h-12 bg-card border-charcoal/10 rounded-xl" data-testid="filter-category">
            <Filter className="w-4 h-4 mr-2 text-muted-foreground" />
            <SelectValue placeholder="Category" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All Categories</SelectItem>
            {CATEGORIES.map(cat => (
              <SelectItem key={cat.value} value={cat.value}>{cat.label}</SelectItem>
            ))}
          </SelectContent>
        </Select>

        <Select value={filterCompleted} onValueChange={onCompletedChange}>
          <SelectTrigger className="w-[140px] h-12 bg-card border-charcoal/10 rounded-xl" data-testid="filter-status">
            <SelectValue placeholder="Status" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All Status</SelectItem>
            <SelectItem value="pending">Pending</SelectItem>
            <SelectItem value="completed">Completed</SelectItem>
          </SelectContent>
        </Select>

        {sortOrder !== undefined && onSortOrderChange && (
          <Button
            variant="outline"
            className="h-12 bg-card border-charcoal/10 rounded-xl"
            onClick={() => onSortOrderChange(sortOrder === "desc" ? "asc" : "desc")}
            data-testid="sort-order-toggle"
          >
            <ArrowUpDown className="w-4 h-4 mr-2" />
            {sortOrder === "desc" ? "Newest" : "Oldest"}
          </Button>
        )}
      </div>
    </div>
  );
};

export default ItemsFilter;
